module.exports = __webpack_public_path__ + "img/rentdeer.46191a40.png";